import { useEffect, useRef, useCallback } from "react";

function useTimeout(callback, delay, startOnMount = true) {
  const savedCallback = useRef(callback);
  const timerId = useRef(null);

  // Keep ref up-to-date with latest callback
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the timeout
  const set = useCallback(() => {
    if (typeof delay === "number") {
      timerId.current = setTimeout(() => {
        savedCallback.current();
      }, delay);
    }
  }, [delay]);

  // Clear the timeout
  const clear = useCallback(() => {
    if (timerId.current) {
      clearTimeout(timerId.current);
      timerId.current = null;
    }
  }, []);

  // Start the timer on mount if startOnMount is true, clean on unmount
  useEffect(() => {
    if (startOnMount) {
      set();
    }
    return clear;
  }, [set, clear, startOnMount]);

  return {
    clear,
    reset: () => {
      clear();
      set();
    },
  };
}

export default useTimeout;
